import * as React from 'react'
import Navbar from './navbar'

import './../../styles/shared/page.css'

class Page extends React.Component {
  render () {
    return (
      <div className='page-container'>
        <Navbar history={this.props.history} />
        {this.props.children}
      </div>
    )
  }
}

export default Page



// WEBPACK FOOTER //
// ./src/components/shared/page.js